const $ = jQuery.noConflict();
import '@fancyapps/fancybox';

'use strict';
const Fancybox = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domDeleteList: $('.individual-list__info-right-delete'),

	/** @description Initialize */
	init: function() {
		this.fancyboxPopup('.js-popup-trigger', '.js-popup', 'popup-custom-class');
		this.fancyboxPopup('.js-popup-login-trigger', '.js-popup-login', 'popup-custom-class');
		this.fancyboxPopup('.js-contact', '.js-contact-popup');
		this.fancyboxPopup('.js-order-popup-btn', '.js-order-popup');

		Fancybox.$domDeleteList.each((i, el) => {
			const confPopup = $(el).parents('.individual-list').find('.js-popup');
			Fancybox.fancyboxPopup(el, confPopup);
		});

        $('.js-search-zoom-img').each((i, el) => {
            const searchPopup = $(el).parents('.js-search-popup').find('.js-product-info-box-popup');
            Fancybox.fancyboxPopup(el, searchPopup);
        });

		Fancybox.checkAndShowSalePopup();

		$('.js-sale-popup-opener').each((i, el) => {
			Fancybox.fancyboxPopup(el, $('.js-sale-popup'));
		});
	},

	/**
	 * @description Fancy box custom popup functionality.
	 * @link documentation https://fancyapps.com/fancybox/3/docs/#inline
	 * @example this.functions.fancyboxPopup('.popup-btn', '.popup', 'my-custom-class');
	 * @param {string} trigger - popup trigger
	 * @param {string} popup - popup wrapper class
	 * @param {string} customClass - custom class for each popup (optional)
	 */
	fancyboxPopup: (trigger, popup, customClass = '') => {
		$(trigger).fancybox({
			src: popup,
			type: 'inline',
			smallBtn: true,
			baseClass: customClass,
			touch: false
		});
	},

	checkAndShowSalePopup: function() {
		const popupData = JSON.parse(localStorage.getItem('popupDisplayed'));
		const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;

		if (!$('body').hasClass('home') && !$('body').hasClass('woocommerce-cart')) {
			return;
		}

		if (!popupData || new Date().getTime() > popupData.expiration) {
			setTimeout(() => {
				$('.js-sale-popup-opener').trigger('click');
			}, 100);

			localStorage.setItem(
				'popupDisplayed',
				JSON.stringify({
					displayed: true,
					expiration: new Date().getTime() + sevenDaysInMs
				})
			);
		}

		const codeButton = $('.js-sale-popup__button-text');
		const notice = $('.js-sale-popup__button-text-notice');
		codeButton.on('click', function() {
			const textToCopy = $.trim($(this).text());
			console.log('btn click');

			const tempTextarea = $('<textarea>');
			$('body').append(tempTextarea);

        	tempTextarea.val(textToCopy).select();
			document.execCommand('copy');

			tempTextarea.remove();

			notice.addClass('show-notice');
			setTimeout(() => {
				notice.removeClass('show-notice');
			}, 1500);
		});
	},
};

export default Fancybox;